import React, { useDispatch, useGlobal, useState, useEffect } from 'reactn'
import { QuestionOutlineIcon, RepeatIcon } from '@chakra-ui/icons'
import {
  Box,
  Button,
  Center,
  HStack,
  VStack,
  Flex,
  RadioGroup,
  Radio,
  IconButton,
  Image,
} from "@chakra-ui/react"
import { formatPrice } from '../../../utils/format-price'
import { Dots } from "../dotsAnimation"

const ShippingForm = ({ reload, allowSelection, globalState, isDisabled }) => {
  const { store } = globalState
  const { ts, so, fetchingCartData, shippingError, fetchingShipping, shipping_address } = store
  const [packagingOptions] = useGlobal("packagingOptions")
  const [rate, setRate] = useState(ts && ts.shipping_line ? ts.shipping_line.id : so ? so[0].id : "")
  const [pack, setPack] = useState(0)

  const setShipping = useDispatch("setShipping")
  const setPackagingOption = useDispatch("setPackagingOption")
  const clearShipping = useDispatch("clearShipping")
  const fetchShippingRates = useDispatch("fetchShippingRates")

  const {
    shipping_line = {
      title: "",
    },
  } = ts

  const selectRate = (rateNumber) => {
    if (so && so.length > 0) {
      setShip(so[rateNumber])
      setRate(so[rateNumber].id)
    } else {
      clearShipping()
    }
  }

  const setShip = (rate) => {
    setShipping(rate)
  }

  const selectPacak = (packNumber) => {
    if (packagingOptions && packagingOptions.length > 0) {
      setP(packagingOptions[packNumber])
      setPack(Number(packNumber))
    }
  }

  const setP = (pk) => {
    setPackagingOption(pk)
  }

  useEffect(() => {
    selectRate(0)
  }, [shipping_address.country_code])

  useEffect(() => {
    if (
      ts &&
      ts.shipping_line &&
      ts.shipping_line.id &&
      ts.shipping_line.id != rate
    ) {
      selectRate(0)
    }
  }, [ts.shipping_line.id])

  useEffect(() => {
    if (reload) {
      fetchShippingRates()
    }
  }, [reload])

  return (
    <>
      <Box ml={0} mr={0}>
        <HStack>
          {fetchingShipping && (
            <Box width="100%">
              <Center>
                <Dots mb={5} size="xs" />
              </Center>
            </Box>
          )}
        </HStack>
        <>
          {shippingError ? (
            <HStack mt={0}>
              <Box mt={0}>{shippingError}</Box>
              <IconButton
                border={"none"}
                onClick={() => fetchShippingRates()}
                icon={<RepeatIcon w={5} h={5} color={"black"} />}
                variant={"unstyled"}
                aria-label={"Fetch Shipping Rates"}
              >
                {" "}
              </IconButton>
            </HStack>
          ) : (
            <Box ml={[0, 0, 0, 0]} mr={[0, 0, 0, 0]}>
              {allowSelection ? (
                <RadioGroup mt={0} value={rate} id="shippingRadio">
                  <VStack>
                    {so &&
                      so.map((rate, index) => (
                        <Button
                          borderWidth={1}
                          isDisabled={isDisabled || fetchingShipping || fetchingCartData}
                          key={`shi${index}`}
                          minWidth={"100%"}
                          variant={"shipping"}
                          onClick={() => selectRate(index)}
                        >
                          <Flex>
                            <Box textAlign={"left"}>
                              <Radio fontSize={"16px"} colorScheme={"black"} value={rate.id}>
                                {rate.detail}{" "}
                              </Radio>
                              <Box fontSize={11} ml={"20px"}>
                                USUALLY DELIVERED WITHIN {rate.delivery} DAYS
                              </Box>
                            </Box>
                            <Box flex="1" fontSize={"16px"} textAlign={"right"} mr={"10px"}>
                              {formatPrice(rate.amount)}
                            </Box>
                          </Flex>
                        </Button>
                      ))}
                  </VStack>
                </RadioGroup>
              ) : (
                <Flex>
                  <Box textAlign={"left"}>
                    <Box fontSize={"16px"} colorScheme={allowSelection ? "black" : "white"}>
                      {shipping_line.title.split('/')[2].trim()}
                    </Box>
                    {/* <Box fontSize={11} ml={'20px'}>{shipping_line.delivery}</Box> */}
                  </Box>
                  <Box flex="1" fontSize={"16px"} textAlign={"right"} mr={"10px"}>
                    {formatPrice(shipping_line.price)}
                  </Box>
                </Flex>
              )}

              {packagingOptions && packagingOptions.length > 0 && (
                <Box id="packiging">
                  <Box textAlign={"left"} fontSize={14} fontWeight={900} mt={4}>
                    PACKAGING
                  </Box>
                  <HStack spacing={2} ml={0} mt={1} mb={1}>
                    <Box textAlign={"left"} fontSize={[12, 12, 12, 12]} fontWeight={900}>
                      {" "}MINIMiSE YOUR CARBON IMPACT
                    </Box>
                    <QuestionOutlineIcon w={5} h={5} color={"green"} />
                  </HStack>
                  <Box ml={0} mr={0}>
                    <RadioGroup mt={0} value={pack}>
                      <VStack>
                        {packagingOptions &&
                          packagingOptions.map((pack, index) => (
                            <Button
                              disabled={fetchingShipping || fetchingCartData}
                              key={`shi${index}`}
                              minWidth={"100%"}
                              variant={pack.isCircular ? "packagingCircular" : "packaging"}
                              onClick={() => selectPacak(index)}
                            >
                              <Flex>
                                <Box textAlign={"left"}>
                                  <HStack spacing={0}>
                                    <Box>
                                      <Radio
                                        fontWeight={900}
                                        size={pack.isCircular ? "md" : "sm"}
                                        colorScheme={"black"}
                                        value={index}
                                      >
                                        {pack.description}{" "}
                                      </Radio>
                                    </Box>

                                    {pack.isCircular && (
                                      <>
                                        <Box width="20px" height="20px" ml={0}>
                                          <Image margin={0} src="/images/ecl-leaf.svg" />
                                        </Box>
                                      </>
                                    )}
                                  </HStack>
                                </Box>
                                <Box
                                  flex="1"
                                  textAlign={"right"}
                                  textTransform="none"
                                  mr={"10px"}
                                  minWidth={10}
                                >
                                  {pack.costText}{" "}
                                </Box>
                              </Flex>
                              <Box
                                ml={pack.isCircular ? "22px" : "20px"}
                                textAlign="left"
                                color={"black"}
                                mt={2}
                                fontWeight={400}
                                fontSize={11}
                              >
                                {pack.benefitShort}
                              </Box>
                            </Button>
                          ))}
                      </VStack>
                    </RadioGroup>
                  </Box>
                </Box>
              )}
            </Box>
          )}
        </>
      </Box>
    </>
  )
}

export default ShippingForm